export const NAME = 'accountLinkedOffer';

export const REQUEST_ALO_CONNECTIONS = 'REQUEST_ALO_CONNECTIONS';
export const RECEIVE_ALO_CONNECTIONS = 'RECEIVE_ALO_CONNECTIONS';
export const FAILURE_ALO_CONNECTIONS = 'FAILURE_ALO_CONNECTIONS';

export const REQUEST_ALO_DELETE_CONNECTION = 'REQUEST_ALO_DELETE_CONNECTION';
export const SUCCESS_ALO_DELETE_CONNECTION = 'SUCCESS_ALO_DELETE_CONNECTION';
export const FAILURE_ALO_DELETE_CONNECTION = 'FAILURE_ALO_DELETE_CONNECTION';

export const REQUEST_ALO_DELETE_ACCOUNT = 'REQUEST_ALO_DELETE_ACCOUNT';
export const SUCCESS_ALO_DELETE_ACCOUNT = 'SUCCESS_ALO_DELETE_ACCOUNT';
export const FAILURE_ALO_DELETE_ACCOUNT = 'FAILURE_ALO_DELETE_ACCOUNT';

export const REQUEST_ALO_REACTIVATE_ACCOUNT = 'REQUEST_ALO_REACTIVATE_ACCOUNT';
export const SUCCESS_ALO_REACTIVATE_ACCOUNT = 'SUCCESS_ALO_REACTIVATE_ACCOUNT';
export const FAILURE_ALO_REACTIVATE_ACCOUNT = 'FAILURE_ALO_REACTIVATE_ACCOUNT';



// WEBPACK FOOTER //
// ./src/services/account/alo/constants.js